import axios from 'axios'
import {message} from "ant-design-vue";

const request = axios.create({
    timeout: 50000
})
export const domain='/api'//'http://192.168.68.244:8080/api'
request.interceptors.request.use(config => {
    config.baseURL = //'/api'
    // 'http://localhost:8080/api'
        domain
    const token = localStorage.getItem("token")
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})
let isRedirecting = false;
request.interceptors.response.use(
    res => res,
    error => {
        if (error.response?.status === 401) {
            if (!isRedirecting) {
                isRedirecting = true;
                message.error("登录已过期，请重新登录")
                localStorage.removeItem("token")
                router.push("/login").finally(() => {
                    isRedirecting = false;
                })
            }
        }
        return Promise.reject(error)
    }
)
export default request